<template>
  <!-- 设置严禁词弹窗 -->
  <VhallDialog width="720px" :title="$t('lang.k_343001')" :visible="visible" @close="handleClose">
    <vh-form :model="settingForm" ref="settingForm" label-width="120px">
      <vh-form-item label="" prop="intercept_way">
        <div slot="label">
          <span style="margin-right: 2px">{{ $t('lang.k_343002') }}</span>
          <vh-tooltip>
            <div slot="content">
              {{ $t('lang.k_343003') }}
              <br />
              {{ $t('lang.k_343004') }}
            </div>
            <i class="iconfont-v3 saasicon_help_m"></i>
          </vh-tooltip>
        </div>
        <vh-radio v-model="settingForm.intercept_way" :label="0">
          {{ $t('lang.k_343005') }}
        </vh-radio>
        <vh-radio v-model="settingForm.intercept_way" :label="1">
          {{ $t('lang.k_343006') }}
        </vh-radio>
      </vh-form-item>
      <vh-form-item :label="$t('lang.k_343007')" prop="filter_mobile_switch">
        <vh-switch
          v-model="settingForm.filter_mobile_switch"
          :active-value="filterMobileSwitchCfg.activeValue"
          :inactive-value="filterMobileSwitchCfg.inactiveValue"
          active-color="#FB3A32"
          inactive-color="#CECECE"
        ></vh-switch>
        <span class="leve3_title title--999" style="vertical-align: text-top">
          {{
            settingForm.filter_mobile_switch != filterMobileSwitchCfg.activeValue
              ? filterMobileSwitchCfg.inactiveTip
              : filterMobileSwitchCfg.activeTip
          }}
        </span>
      </vh-form-item>
      <vh-form-item :label="$t('lang.k_343008')" prop="filter_qq_switch">
        <vh-switch
          v-model="settingForm.filter_qq_switch"
          :active-value="filterQqSwitchCfg.activeValue"
          :inactive-value="filterQqSwitchCfg.inactiveValue"
          active-color="#FB3A32"
          inactive-color="#CECECE"
        ></vh-switch>
        <span class="leve3_title title--999" style="vertical-align: text-top">
          {{
            settingForm.filter_qq_switch != filterQqSwitchCfg.activeValue
              ? filterQqSwitchCfg.inactiveTip
              : filterQqSwitchCfg.activeTip
          }}
        </span>
      </vh-form-item>
      <vh-form-item :label="$t('lang.k_343009')" prop="special_role_switch">
        <vh-switch
          v-model="settingForm.special_role_switch"
          :active-value="specialRoleSwitchCfg.activeValue"
          :inactive-value="specialRoleSwitchCfg.inactiveValue"
          active-color="#FB3A32"
          inactive-color="#CECECE"
        ></vh-switch>
        <span class="leve3_title title--999" style="vertical-align: text-top">
          {{
            settingForm.special_role_switch != specialRoleSwitchCfg.activeValue
              ? specialRoleSwitchCfg.inactiveTip
              : specialRoleSwitchCfg.activeTip
          }}
        </span>
      </vh-form-item>
    </vh-form>
    <div slot="footer" class="dialog-footer">
      <vh-button size="medium" plain round @click="handleClose">
        {{ $t('lang.k_343010') }}
      </vh-button>
      <vh-button
        type="primary"
        :disabled="!isInited"
        v-preventReClick
        size="medium"
        round
        @click="handleSubmit"
      >
        {{ $t('lang.k_343011') }}
      </vh-button>
    </div>
  </VhallDialog>
</template>
<script>
  import to from 'await-to-js';
  export default {
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      visible(newVal) {
        if (newVal) {
          this.isInited = false;
          this.getSettingInfo();
        }
      }
    },
    data() {
      return {
        isInited: false,
        settingForm: {
          intercept_way: 0, // 拦截方式，0-严禁词仅自己可见 1-严禁词以*的形式发出
          filter_mobile_switch: 0, // 过滤手机号，0-关 1-开，仅针对11位手机号，默认0
          filter_qq_switch: 0, //过滤QQ号，0-关 1-开，默认0
          special_role_switch: 1 // 对特殊角色生效，0-关 1-开，默认1
        },
        filterMobileSwitchCfg: {
          activeValue: 1,
          activeTip: this.$t('lang.k_343012'),
          inactiveValue: 0,
          inactiveTip: this.$t('lang.k_343013')
        },
        filterQqSwitchCfg: {
          activeValue: 1,
          activeTip: this.$t('lang.k_343014'),
          inactiveValue: 0,
          inactiveTip: this.$t('lang.k_343015')
        },
        specialRoleSwitchCfg: {
          activeValue: 1,
          activeTip: this.$t('lang.k_343016'),
          inactiveValue: 0,
          inactiveTip: this.$t('lang.k_343017')
        }
      };
    },
    methods: {
      handleClose() {
        this.$emit('update:visible', false);
      },
      async getSettingInfo() {
        let [err, res] = await to(this.$fetch('getKeywordSetting', {}));
        if (err || !res || res.code != 200) {
          this.$message.error(err.msg || res?.msg || this.$t('lang.k_343018'));
          return false;
        }
        if (res?.data) {
          this.settingForm = {
            ...res.data
          };
          this.isInited = true;
        }
      },
      async handleSubmit() {
        const params = {
          ...this.settingForm
        };
        const [err, res] = await to(this.$fetch('saveKeywordSetting', params));
        if (err || !res || res.code != 200) {
          this.$message.error(err.msg || res?.msg || this.$t('lang.k_343018'));
          return false;
        }
        this.$message.success(this.$t('lang.k_343019'));
        this.handleClose();
      }
    }
  };
</script>
